import { combineReducers } from 'redux';
import { reducer as formReducer } from 'redux-form';
import {
  searchReducer,
  searchExportReducer,
  searchDetailsReducer,
  searchHistoryReducer,
} from 'pages/Search';
import {
  propertySearchReducer,
  propertySearchDetailsReducer,
} from 'pages/PropertySearch';
import { taxMapsReducer } from 'pages/TaxMaps';
import { loginReducer } from 'pages/Login';
import { recentReportsReducer } from 'pages/RecentReports';
import { ReducerNames } from 'common';
import { depOnlineReducer } from 'pages/DepOnline';
import { xosImageReducer } from 'pages/XosImages';
import { bankruptcyReducer } from 'pages/Bankruptcy';
import { preacrisReducer } from 'pages/Preacris';
import { licenseReducer } from 'pages/License';
import { userUsageReportReducer } from 'pages/UserUsageReport';
import {
  taxTraxReducer,
  taxTraxTaxBillsReducer,
  taxTraxTaxBillRecordReducer,
} from 'pages/TaxTrax';
import { maintenanceMessageReducer } from 'common/components/MaintenanceMessage';

const {
  SEARCH,
  SEARCH_EXPORT,
  SEARCH_DETAILS,
  LOGIN,
  FORM,
  SEARCH_HISTORY,
  PROPERTY_SEARCH,
  PROPERTY_SEARCH_DETAILS,
  RECENT_REPORTS,
  TAX_MAPS,
  DEP_ONLINE,
  BANKRUPTCY,
  XOSIMAGE,
  PREACRIS,
  LICENSE,
  USER_USAGE_REPORT,
  TAXTRAX,
  TAXTRAX_TAX_BILLS,
  TAXTRAX_TAX_BILL_RECORD,
  MAINTENANCE_MESSAGE,
} = ReducerNames;

const rootReducer = combineReducers({
  [SEARCH]: searchReducer,
  [SEARCH_EXPORT]: searchExportReducer,
  [SEARCH_DETAILS]: searchDetailsReducer,
  [LOGIN]: loginReducer,
  [FORM]: formReducer,
  [SEARCH_HISTORY]: searchHistoryReducer,
  [PROPERTY_SEARCH]: propertySearchReducer,
  [PROPERTY_SEARCH_DETAILS]: propertySearchDetailsReducer,
  [RECENT_REPORTS]: recentReportsReducer,
  [TAX_MAPS]: taxMapsReducer,
  [DEP_ONLINE]: depOnlineReducer,
  [BANKRUPTCY]: bankruptcyReducer,
  [XOSIMAGE]: xosImageReducer,
  [PREACRIS]: preacrisReducer,
  [LICENSE]: licenseReducer,
  [USER_USAGE_REPORT]: userUsageReportReducer,
  [TAXTRAX]: taxTraxReducer,
  [TAXTRAX_TAX_BILLS]: taxTraxTaxBillsReducer,
  [TAXTRAX_TAX_BILL_RECORD]: taxTraxTaxBillRecordReducer,
  [MAINTENANCE_MESSAGE]: maintenanceMessageReducer,
});

export default rootReducer;
